/** Landing pages that show the sticky gold compare button at the bottom on mobile. */
export const MOBILE_STICKY_COMPARE_INVITE_PATHS = [
  "/invite-al",
  "/invite-az",
  "/invite-co",
  "/invite-ct",
  "/invite-ga",
  "/invite-md",
  "/invite-mo",
  "/invite-ms",
  "/invite-nc",
  "/invite-or",
  "/invite-sc",
  "/invite-tn",
  "/invite-tx",
  "/invite-va",
  "/invite-wa",
] as const;

/** Landing pages that show the sticky navy call icon in the mobile header. */
export const MOBILE_HEADER_CALL_PATHS = [
  "/121",
  "/shop-rates",
  "/shop-rates-b",
  "/gnews-al",
  "/gnews-az",
  "/gnews-co",
  "/gnews-ct",
  "/gnews-ga",
  "/gnews-in",
  "/gnews-ky",
  "/gnews-md",
  "/gnews-mn",
  "/gnews-mo",
  "/gnews-ms",
  "/gnews-nc",
  "/gnews-nj",
  "/gnews-nm",
  "/gnews-nv",
  "/gnews-oh",
  "/gnews-or",
  "/gnews-pa",
  "/gnews-sc",
  "/gnews-tn",
  "/gnews-tx",
  "/gnews-ut",
  "/gnews-va",
  "/gnews-wa",
  "/gc-az",
  "/gc-ga",
  "/gc-nc",
  "/gc-tn",
  "/gc-va",
  "/gc-wa",
  "/gc2-az",
  "/gc2-ga",
  "/gc2-nc",
  "/gc2-tn",
  "/gc2-va",
  "/gc2-wa",
  ...MOBILE_STICKY_COMPARE_INVITE_PATHS,
] as const;

const MOBILE_HEADER_CALL_PATH_SET = new Set<string>(
  MOBILE_HEADER_CALL_PATHS.map((path) => path.toLowerCase()),
);

const MOBILE_STICKY_COMPARE_INVITE_PATH_SET = new Set<string>(
  MOBILE_STICKY_COMPARE_INVITE_PATHS.map((path) => path.toLowerCase()),
);

export function isMobileHeaderCallLandingPage(pathname: string): boolean {
  if (!pathname) return false;

  const normalizedPath = pathname.split("?")[0].replace(/\/$/, "") || "/";
  const lowerPath = normalizedPath.toLowerCase();

  if (MOBILE_HEADER_CALL_PATH_SET.has(lowerPath)) {
    return true;
  }

  if (lowerPath.startsWith("/gs-route/gnews/")) {
    return true;
  }

  if (lowerPath.startsWith("/gs-route/gc/")) {
    return true;
  }

  if (lowerPath.startsWith("/gs-route/gc2/")) {
    return true;
  }

  if (lowerPath.startsWith("/gs-route/invite/")) {
    return true;
  }

  return false;
}

export function isMobileStickyCompareInvitePage(pathname: string): boolean {
  if (!pathname) return false;

  const normalizedPath = pathname.split("?")[0].replace(/\/$/, "") || "/";
  const lowerPath = normalizedPath.toLowerCase();

  if (MOBILE_STICKY_COMPARE_INVITE_PATH_SET.has(lowerPath)) {
    return true;
  }

  if (lowerPath.startsWith("/gs-route/invite/")) {
    return true;
  }

  return false;
}
